import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveComWixpressMembersDefaultprivacyDefaultPrivacyStatusUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'api._api_base_domain_': [
      {
        srcPath: '/members-default-privacy-status-api',
        destPath: '',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/members/v1/default-privacy-status',
        destPath: '/v1/default-privacy-status',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/members/v1/default-privacy-status',
        destPath: '/v1/default-privacy-status',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/members/v1/default-privacy-status',
        destPath: '/v1/default-privacy-status',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/members/v1/default-privacy-status',
        destPath: '/v1/default-privacy-status',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/members/v1/default-privacy-status',
        destPath: '/v1/default-privacy-status',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_members_default-privacy';

/** Retrieves the default privacy status of a site. */
export function getDefaultPrivacyStatus(
  payload: object
): RequestOptionsFactory<any> {
  function __getDefaultPrivacyStatus({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.members.v1.default_privacy',
      method: 'GET' as any,
      methodFqn:
        'com.wixpress.members.defaultprivacy.DefaultPrivacyStatus.GetDefaultPrivacyStatus',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressMembersDefaultprivacyDefaultPrivacyStatusUrl({
        protoPath: '/v1/default-privacy-status',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __getDefaultPrivacyStatus;
}

/** Sets the default privacy status of a site. */
export function setDefaultPrivacyStatus(
  payload: object
): RequestOptionsFactory<any> {
  function __setDefaultPrivacyStatus({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.members.v1.default_privacy',
      method: 'PATCH' as any,
      methodFqn:
        'com.wixpress.members.defaultprivacy.DefaultPrivacyStatus.SetDefaultPrivacyStatus',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressMembersDefaultprivacyDefaultPrivacyStatusUrl({
        protoPath: '/v1/default-privacy-status',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __setDefaultPrivacyStatus;
}
